import { createTheme } from '@mui/material/styles';

export const lightTheme = createTheme();
export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});
